module.exports = __webpack_public_path__ + "static/media/hand-scissors.278b40c9.svg";